import { MouseEvent } from "react";
import {
  IconButton,
  TableRowActions,
  Tooltip,
  useToast,
} from "@songtradr-one/components-frontend";
import { LinkIcon } from "@songtradr/component-library";
import { errorText } from "../../statics/error-text";
import { CopyLinkProps, text } from "./CopyLink.Parts";

/**
 * A component used to copy a link to the clipboard
 *
 * This component uses the useToast hook to display error messages and therefore must be used within a ToastProvider.
 *
 * @param link - The link to be copied to the clipboard.
 */
export const CopyLink = ({ link }: CopyLinkProps) => {
  const { addToast } = useToast();

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();

    if (!link) {
      addToast({ text: errorText["CopyLink.Failed"].message });
      return;
    }

    navigator.clipboard.writeText(link);
    addToast({ text: text.success, variant: "share" });
  };

  return (
    <TableRowActions>
      <Tooltip tip={text.tip}>
        <IconButton onClick={handleClick}>
          <LinkIcon />
        </IconButton>
      </Tooltip>
    </TableRowActions>
  );
};
